import { lazy, Suspense, useRef, useEffect } from 'react';
import { Box } from '@mui/material';
import CardLoading from './CardLoading';
import { useLayoutStore } from '../hooks/screen/useLayoutStore';
import { useScreenStore } from '../stores/useScreenStore';
const LineCard = lazy(() => import('./LineCard'));

const LineCardsView = ({ lines, endOfListRef, resetScrollKey }) => {

  const containerRef = useRef(null);

  const isCompactMode = useLayoutStore(
    state => state.isCompactMode
  );

  const monitorMode = useScreenStore(state => state.monitorMode);

  useEffect(() => {
  
    containerRef.current?.scrollTo({
      top: 0,
      behavior: 'auto'
    });

  }, [resetScrollKey]);

  return (
    <Box
      data-compact-scroll-ignore
      ref={containerRef}
      sx={{
        flex: 1,
        overflow: 'auto',
        p: 4,
        pl: (monitorMode === 1 && isCompactMode) ? 10 : 4
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: 2
        }}
      >
        {lines.map(line => (
          <Suspense
            key={line.CODIGO_INTEGRACAO}
            fallback={<CardLoading />}
          >
            <LineCard line={line}/>
          </Suspense>
        ))}

        <div
          ref={endOfListRef}
          style={{ height: 10 }}
        />
      </Box>
    </Box>
  );
};

export default LineCardsView;